<template>
    <div class="shade" :class="{hide: !show}" ref="shade">
        <slot></slot>
    </div>
</template>

<script>
export default {
    props: {
        show: Boolean
    },
}
</script>

<style scoped>
    .shade {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }

    .shade:before {
        content: "";
        display: block;
        height: 100%;
        background: rgba(0, 0, 0, .6);
        transition: opacity .18s;
    }

    .shade.hide:before {
        opacity: 0;
    }
</style>